module.exports = __webpack_public_path__ + "images/top-topics-placeholder-1.jpg";